import { BaseModel } from './BaseModel';

// Backup drivers that support the read-only live "Explore" mount: deduplicating
// repositories the daemon can mount over FUSE (borgv2 and rustic). Kept in one
// place so the Explore button, the explore-view guard, and the daemon mount op
// all agree on which drivers are explorable.
export const EXPLORABLE_BACKUP_DRIVERS = ['borgv2', 'rustic'] as const;

export function isExplorableBackupDriver(driver: string | null | undefined): boolean {
    return !!driver && (EXPLORABLE_BACKUP_DRIVERS as readonly string[]).includes(driver);
}

export class Backup extends BaseModel {
    public uuid = '';
    public uuidShort = '';
    public name = '';
    public ignoredFiles: string[] | null = null;
    public sha256Hash = '';
    // bytes is the compressed/on-disk storage size (what the backup costs and is
    // billed on). actualBytes is the logical, uncompressed size; it is null for
    // legacy backups created before the daemon reported it, in which case the UI
    // shows the actual size blank.
    public bytes = -1;
    public actualBytes: number | null = null;
    public driver: string | null = null;
    public locked = false;
    public creating = false;
    public isSuccessful = false;
    public completedAt: string | null = null;
    public createdAt = '';

    // The client {backup} route param resolves by uuidShort (see the panel's
    // SubstituteClientApiBindings middleware), so model binding needs this.
    public getRouteID(): string {
        return this.uuidShort;
    }
}
